// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sf-0";
export var checkoutRateBadgeLink = "_sf-1";